<div class="customers-container">
  <app-datatable
    [rowData]="dataSource().data"
    [columns]="datatableColumns"
    [configurationInput]="datatableConfig"
    [customColumnDef]="[
      { name: 'name', isSortable: true, template: customerColumn },
      { name: 'campaigns', isSortable: true, template: campaignsColumn },
      { name: 'actions', isSortable: false, template: actionsColumn },
      { name: 'created', isSortable: true, template: createdColumn },
    ]"
    [total]="dataSource().data.length"
    [loaderConfig]="skeletonLoaderConfig"
    [isInitialDataLoaded]="loadedTableData()"
    [loadingData]="customersLoading()"
    (rowClick)="onRowClick($event)"
  />

  <ng-template #customerColumn let-row="row" let-index="index">
    <div class="flex items-center gap-2">
      <app-icon-badge
        [content]="row.iconId"
        [fallbackBackgroundColor]="index % 2 === 0 ? 'var(--shikenso-base-white)' : 'var(--shikenso-gray-base)'"
        [fallbackText]="row.name"
        [borderRadius]="100"
        [size]="40"
        [iconSize]="40"
        [fontSize]="16"
        alt="Avatar"
      />
      <span class="font-bold">{{ row.name }}</span>
    </div>
  </ng-template>

  <ng-template #createdColumn let-row="row">
    <div class="flex items-center gap-2">
      <app-icon src="/icons/calendar-event.svg" alt="Created" [size]="16" />
      <span>{{ row.createdAt | date: 'dd.MM.yyyy' }}</span>
    </div>
  </ng-template>

  <ng-template #campaignsColumn let-row="row">
    <div class="flex items-center">
      <div class="w-9 h-9 flex items-center justify-center">
        <app-icon src="/icons/campaigns.svg" alt="Campaign" [size]="16" />
      </div>
      <span>{{ row.campaigns?.length }}</span>
    </div>
  </ng-template>

  <ng-template #actionsColumn let-row="row">
    <div *hasPermission="[EPermissions.customerDeleteOwn]" class="flex items-center justify-start">
      <button
        mat-icon-button
        class="mat-secondary-transparent-button-color"
        [matMenuTriggerFor]="menu"
        (click)="$event.stopPropagation()"
      >
        <app-icon src="/icons/three-dots.svg" alt="More" [size]="16" />
      </button>
      <mat-menu #menu="matMenu">
        <button *hasPermission="[EPermissions.customerDeleteOwn]" mat-menu-item (click)="onDeleteClick($event, row)">
          {{ 'shared.form.delete' | translate }}
        </button>
      </mat-menu>
    </div>
  </ng-template>
</div>
